import templateUrl from 'emun.on-demand/media/od-media-manager.htm'
import resolve from 'ioc/resolve'
import MediaManagerController from 'emun.on-demand/media/od-media-manager.controller'

let MediaManagerComponent = {
    bindings: {
        hideLeftNav: '@',
        hideHeader: '@',
        hideEmptyGroupings: '@',
        maxPanelHeight: '@',
        hideGroupingCounts: '@',
        panelMaxHeight: '@',
        panelType: '@',
        actions: '@', //select,detail,applyToProducts,addToDesign
        title: '@',
        criteria: '<?',
        tagCriteria: '<?',
        queryOptions: '<?',
        navs: '<?',
        filters: '<?',
        onPublish: '&',
        onSaved: '&'
    },
    controller: MediaManagerController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default MediaManagerComponent;
